var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_43",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m74.458,40.968l-4.795,46.847c-.052.51-.482.898-.995.898H31.791c-.513,0-.943-.388-.995-.898l-4.795-46.847c-.06-.589.402-1.102.995-1.102h46.467c.593,0,1.055.512.995,1.102Z",
        },
      }),
      _c("rect", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          x: "36.635",
          y: "59.56",
          width: "10.285",
          height: "10.285",
          rx: "1",
          ry: "1",
          transform: "translate(57.988 -10.59) rotate(45)",
        },
      }),
      _c("rect", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          x: "54.259",
          y: "69.364",
          width: "9.855",
          height: "9.855",
          rx: "1",
          ry: "1",
          transform: "translate(32.658 -16.914) rotate(22.326)",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "48.621", y1: "64.541", x2: "71.84", y2: "64.541" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "28.696", y1: "64.541", x2: "35.148", y2: "64.541" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }